export default "__VITE_ASSET__DFj$nIYt__"